module.exports = __webpack_public_path__ + "static/label-warning-791f952edbf326d996b311160bed8eb1.png";